import axios from '@/plugins/axios'

export function getBikes(params = {}) {
  return axios.get('bike', {
    params,
  })
}

export function getMapBikes(params = {}) {
  return axios.get('bike/maps', {
    params,
  })
}

export function storeBike(data) {
  return axios.post('bike', data)
}

export function updateBike(id, data) {
  return axios.put(`bike/${id}`, data)
}

export function updateBikeRemark(id, data) {
  return axios.put(`bike/updateRemark/${id}`, data)
}

export function editBike(id) {
  return axios.get(`bike/${id}/edit`)
}

export function bikeQrCode(params = {}) {
  return axios.get('bike/qrCode', {
    params,
  })
}

export function destroyBike(id) {
  return axios.delete(`bike/${id}`)
}

export function bikesUpdate(data = {}) {
  return axios.post('bike/bikesUpdate', data)
}

export function mulBikesContro(data = {}) {
  return axios.post('bike/mulBikesContro', data)
}

export function getBikePosition(data = {}) {
  return axios.post('bike/getBikePosition', data)
}

export function importBikes(file) {
  const data = new FormData()
  data.append('bikes', file)

  return axios.post(`bike/bikesImport`, data)
}

export function downloadBikes() {
  return axios.post(`bike/bikesDownload`)
}

export function downloadBikesQrCodes(params = {}) {
  return axios.get(`bike/qrCodesDownload`, { params,
    responseType: 'arraybuffer' })
}

export function getBikeStatistics(params = {}) {
  return axios.get('bike/statistics', {
    params,
  })
}

export function importBoxs(file) {
  const data = new FormData()
  data.append('boxs', file)

  return axios.post(`box/import`, data)
}

export function downloadBoxs() {
  return axios.post(`box/download`)
}
export function bikeStatusValueLabel() {
  return axios.get(`bike/bikeStatusValueLabel`)
}

export function getTrajectorys(data) {
  return axios.post('bike/getTrajectorys', data)
}
